namespace My {
    export class FastLinkVerificationConfirmOTPPage extends BaseForm<FastLinkVerificationModel, any> {
        protected passwordRecoveryService: PasswordRecoveryService;

        protected numberOfInputs = 6;
        protected otpInputs = $("#otpInputs");
        public otp: string[] = [];
        protected countdownDiv = $('.countdown');
        protected phoneNumberModel = $("#PhoneNumber").val();
        protected $btnSendAgain = $(".btn-send-again");

        constructor(container: JQuery, opt?: any) {
            super(container, opt);
        }

        protected onInit(): void {
            this.passwordRecoveryService = new PasswordRecoveryService();
        }

        protected bindingEvents(): void {
            this.$btnSendAgain.on("click", () => {
                this.sendOtpAgain();
            })
        }

        public async sendOtpAgain() {
            var res = await this.passwordRecoveryService.generateResetPasswordToken(this.phoneNumberModel, false);
            if (res.IsOk) {
                if (res.Code == "0") {
                    $(".time-wrap").removeClass("d-none")
                    this.countdownOneMinute()
                } else {
                    UIUtils.showToastError(Utils.l("ConfirmOtp.OtpError"));
                }
            } else {
                UIUtils.showToastError(Utils.l("ConfirmOtp.OtpError"));
            }
        }

        public countdownOneMinute() {
            $(".btn-send-again").prop("disabled", true)
            var seconds = 60;

            var countdownInterval = setInterval( () =>  {
                $("#seconds").text(seconds);
                seconds--;
                if (seconds < 0) {
                    $("#seconds").text("60");
                    clearInterval(countdownInterval);
                    $(".btn-send-again").prop("disabled", false);
                    $(".time-wrap").addClass("d-none");
                }
            }, 1000);
        }
    }
}